import {AssetExpirationActionLabel} from '../locales';

import type {Action} from '@netx/core/bootstrap';

import {permissionsEnabled} from '@netx/core-permissions-next/enablers';
const permissionsV2Enabled = permissionsEnabled();

import {icon} from '@fortawesome/fontawesome-svg-core';
import {
	faCalendarPlus,
	faCalendarMinus,
} from '@fortawesome/pro-solid-svg-icons';
import {UserLevel} from '@netx/core-user-next/constants';

const iconOpts = {classes: ['fa-fw']};
const icons = {
	faCalendarMinus: icon(faCalendarMinus, iconOpts).html,
	faCalendarPlus: icon(faCalendarPlus, iconOpts).html,
};

export const ASSET_EXPIRATION_ACTION_ICON = <const>{
	EXPIRE: faCalendarPlus,
	UNEXPIRE: faCalendarMinus,
};

export const ASSET_EXPIRATION_ROUTES = <const>{};

export type BaseVent = typeof BASE_EVENT;

export const BASE_EVENT = `asset:expiration`;

export const ASSET_EXPIRATION_EVENT = <const>{
	EXPIRE: `${BASE_EVENT}:expire`,
	UNEXPIRE: `${BASE_EVENT}:unexpire`,
};

export const ACTIONS: Action<
	(typeof ASSET_EXPIRATION_EVENT)[keyof typeof ASSET_EXPIRATION_EVENT]
>[] = [
	{
		event: ASSET_EXPIRATION_EVENT.EXPIRE,
		icon: icons.faCalendarPlus,
		get label() {
			return AssetExpirationActionLabel.EXPIRE;
		},
		userLevel: permissionsV2Enabled ? undefined : UserLevel.MANAGER,
	},
	{
		event: ASSET_EXPIRATION_EVENT.UNEXPIRE,
		icon: icons.faCalendarMinus,
		get label() {
			return AssetExpirationActionLabel.UNEXPIRE;
		},
		userLevel: permissionsV2Enabled ? undefined : UserLevel.MANAGER,
	},
];

export default ACTIONS;
